var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-2{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px}\r\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_289",
    "data-name": "Group 289",
    transform: "translate(-1065 -968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_70",
    d: "M0 0H56V56H0z",
    "data-name": "Rectangle 70",
    transform: "translate(1065 968)",
    style: {
      fill: "#d5d5d5"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_292",
    "data-name": "Group 292",
    transform: "translate(12176 17888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_82",
    d: "M0 0H22.472V5.509H0z",
    className: "prefix__cls-2",
    "data-name": "Rectangle 82",
    transform: "translate(-11094.427 -16889.43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_113",
    d: "M305.31 384.359c-1.933-.725-3.406-3.268-2.48-5.247a7.017 7.017 0 0 1 1.435-1.684 4.608 4.608 0 0 0 1.311-3.142 4.406 4.406 0 0 0-4.406-4.406h.116a4.406 4.406 0 0 0-4.406 4.406 4.608 4.608 0 0 0 1.311 3.142 7.017 7.017 0 0 1 1.435 1.684c.926 1.979-.547 4.522-2.48 5.247z",
    className: "prefix__cls-2",
    "data-name": "Path 113",
    transform: "translate(-11384.491 -17273.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_8",
    d: "M0 0L23.568 0",
    className: "prefix__cls-2",
    "data-name": "Line 8",
    transform: "translate(-11095 -16879.898)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmation);
export default __webpack_public_path__ + "static/media/confirmation.4d03182d1492b753a387730c912e23a8.svg";
export { ForwardRef as ReactComponent };